module.exports = __webpack_public_path__ + "media/military/military_ocs_btn-bc7760db.png";